import React from 'react';
import isEmpty from 'lodash/isEmpty';
import ReactDOM from 'react-dom';

import SlidePanel from '../../components/SlidePanel';
import AddonSliderSelector from './AddonSliderSelector';
import useAddonsContext from './AddonsContext';

interface Props {
  closeModal: () => void;
}

const AddonSlidePanel = ({ closeModal }: Props): JSX.Element | null => {
  const {
    addonProducts,
    slidePanelAddon,
    selectedVariant,
    isPanelOpen,
    closePanel,
    handleSelect,
    handleConfirm,
  } = useAddonsContext();

  const selectAddonOnSlide = (addonSelected) => {
    handleSelect(addonSelected);
    closeModal();
  };

  const hasDiscounts = selectedVariant?.discountedPrice;
  const comparePrice = hasDiscounts && selectedVariant?.price;
  const price = hasDiscounts
    ? selectedVariant?.discountedPrice
    : selectedVariant?.price;

  let inventory;
  if (!isEmpty(selectedVariant)) {
    const addon = addonProducts?.find(
      (addon) => addon.productData?.id === selectedVariant.productId,
    );

    inventory = addon?.productData?.variants?.find(
      (variant) => variant.id === selectedVariant.id,
    )?.inventory;
  }

  const content = (
    <SlidePanel
      open={isPanelOpen}
      onClose={closePanel}
      imgUrl={selectedVariant?.image || slidePanelAddon?.image}
      price={price as string}
      comparePrice={comparePrice as string}
      productName={slidePanelAddon?.title}
      variantName={selectedVariant?.title || ''}
      description={slidePanelAddon?.description}
      isLoading={!slidePanelAddon || isEmpty(slidePanelAddon)}
      isAddon={true}
    >
      {slidePanelAddon ? (
        <AddonSliderSelector
          slidePanelAddon={slidePanelAddon}
          selectedVariant={{ ...selectedVariant, inventory } as GlobalVariant}
          onSelect={selectAddonOnSlide}
          onConfirm={handleConfirm}
        />
      ) : null}
    </SlidePanel>
  );

  const elementId = 'slide-panel';
  let slidePanelDiv = document.getElementById(elementId);

  if (!slidePanelDiv) {
    slidePanelDiv = document.createElement('div');
    slidePanelDiv.id = elementId;
    document.body.appendChild(slidePanelDiv);
  }

  return ReactDOM.createPortal(content, slidePanelDiv);
};

export default AddonSlidePanel;
